import React from 'react';
import { Link } from 'react-router-dom';
import { links } from './links';

const Check = () => (
  <svg fill="currentColor" viewBox="0 0 20 20" aria-hidden>
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
  </svg>
);

const FinalCTA = () => {
  return (
    <section className="cf-section">
      <div className="cf-container cf-rel-z">
        <div className="cf-cta__card cf-reveal cf-reveal--scale">
          <div className="cf-cta__deco cf-cta__deco--a" />
          <div className="cf-cta__deco cf-cta__deco--b" />
          <div className="cf-cta__grid" />

          <div className="cf-cta__inner">
            <span className="cf-cta__pill">Free forever</span>

            <h2 className="cf-cta__title">
              Your best innings,
              <br />
              <em>saved forever.</em>
            </h2>

            <p className="cf-cta__sub">
              Track every run, build your stats, and keep your cricket record for life.
            </p>

            <div className="cf-cta__actions">
              <Link to={links.register} className="cf-cta__btn">Start for Free</Link>
              <Link to={links.login} className="cf-cta__login">Already have an account? Log in</Link>
            </div>

            <div className="cf-cta__badges">
              <div className="cf-cta__badge"><Check /><span>100% Free</span></div>
              <div className="cf-cta__badge"><Check /><span>No card needed</span></div>
              <div className="cf-cta__badge"><Check /><span>Setup in 2 min</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
